export default __webpack_public_path__ + "static/media/imageIcons.4e007773.png";